
// モジュールを読込.
import { Options, Prop, Vue, Watch } from "vue-property-decorator"
import Util from "packs/utils/Util"
import isMobile from "ismobilejs"
import { gtagClick, gtagPage } from "packs/GoogleTagManager"
import { funcName, Logger } from "packs/common"
import { truncate } from "packs/models/TruncateUtil"

// コンポーネントを読込.
import Switcher from "packs/components/forms/Switcher.vue"
import IconHelp from "packs/components/icons/IconHelp.vue"

// モデルを読込.
import RoomManager from "packs/models/RoomManager"
import RoomMember from "packs/models/RoomMember"
import Appointment from "packs/models/Appointment"
import MessageTemplate from "packs/models/MessageTemplate"
import TemplateUtil from "packs/utils/TemplateUtil"
import RoomStorage from "packs/models/RoomStorage"
import RoomCreateManager from "packs/models/RoomCreateManager"
import Room from "packs/models/Room"
import Notice from "packs/models/Notice"
import MailFlow from "packs/models/MailFlow"
import SelectUtil from "packs/utils/SelectUtil"
import DateTag from "packs/models/DateTag"
import AutoCreateRoomRule from "packs/models/AutoCreateRoomRule"

@Options({
    components: {
        Switcher,
        IconHelp,
    },
})
export default class AutoCreateRoomRuleList extends Vue {
    // data:

    @Prop()
    rule: AutoCreateRoomRule

    @Prop()
    mfindex: number

    rm = RoomManager
    rcm = RoomCreateManager
    isSP = isMobile(window.navigator).phone

    // 今回利用するテンプレ.
    localTmp: MessageTemplate = null
    memo = ``
    selectedTabName = this.rcm.room && this.rcm.room.room_type == `parent_room` ? `create_room` : `inquire_on_public_room`

    // テンプレ更新ボタンの表示
    showUpdateTmpButton = false

    currentAppo: Appointment = null
    pubRoomsArray: any[] = []
    publics: string[] = null
    // ボタンに設定している公開ページ
    defaultPubName = null

    sendTimingArray = null
    showSwitchers = false

    SelectUtil = SelectUtil
    truncate = truncate

    public changeActive(rule: AutoCreateRoomRule) {
        Logger(`changeActive: ${Util.output(rule)}`)
        let _rules = this.rcm.ac_rules
        let _rule = _rules.find(_rule => AutoCreateRoomRule.isSame(_rule, rule))
        if (_rule) {
            if (_rule.is_active) {
                _rule.is_active = false
            } else {
                _rule.is_active = true
            }
            this.rcm.updateAutoCreateRoomRule(_rule)
        }
    }

    public editContent(rule) {
        Logger(`${funcName()} rule:${Util.output(rule)}`)
        this.$emit(`editContent`, rule)
    }

    removeRule(rule) {
        this.$emit(`removeRule`, rule)
    }
}
